import { List } from "@material-ui/icons";
import {
  AccountCircle,
  ArticleOutlined,
  Assignment,
  AttachMoney,
  CheckBoxOutlined,
  CheckCircle,
  ComputerOutlined,
  CreditCard,
  CurtainsClosed,
  DynamicFeedOutlined,
  FileCopy,
  MonetizationOn,
  NewspaperOutlined,
  NoteAddOutlined,
  PercentOutlined,
  QueryStats,
  RedoOutlined,
  SummarizeOutlined,
  TabOutlined,
  Money,
  ShoppingCart,
  AccountTree,
  Book,
  AccountBalanceOutlined,
  ShoppingCartCheckout,
  BlindsClosed
} from "@mui/icons-material";
import AssistantPhotoIcon from '@mui/icons-material/AssistantPhoto';
import StyleIcon from '@mui/icons-material/Style';
import MenuItems from "./MenuItems";
import { useSelector } from "react-redux";

const Navbar = () => {
   const { data: user } = useSelector((state) => state.user);
   const headerItems = [
    // {
    //   title: "Dashboard",
    //   url: "/dashboard",
    // },
    {
      title: "Transaction Type",
      url: "/transaction-list",
    },
    {
      title: "Transactions",
      // url: '/services',
      submenu: [
        {
          title: "Order Management",
          icon: <Assignment />,
  
          submenu: [
           
            {
              title: "Credit Memo",
              url: "/transaction-type/credit-memo",
              icon: <AssistantPhotoIcon />,
            },
            // {
            //   title: "Return Authorization",
            //   url: "/transaction-type/return-authorization",
            //   icon: <RedoOutlined />,
            // },
            {
              title: "Customer Invoice",
              url: "/transaction-type/invoice",
              icon: <NoteAddOutlined />,
            },
            {
              title: "Customer Payments",
              url: "/transaction-type/payment",
              icon: <AccountCircle />,
            },
             {
              title: "Cash Sale",
              url: "/transaction-type/cash-sale",
              icon: < AttachMoney />,
            },
          ],
        },
        {
          title: "Purchasing",
          icon: <ShoppingCart />,
          url: "",
  
          submenu: [
            {
              title: "Purchase Order",
              url: "/transaction-type/purchase-order",
              icon: <ShoppingCartCheckout />,
            },
            {
              title: "Vendor Bill List",
              url: "/transaction-type/vendor-bill-list",
              icon: <QueryStats />,
              // submenu: [
              //   {
              //     title: 'NodeJS',
              //     url: 'node',
              //   },
              // ],
            },
            // {
            //   title: "Item Receipt",
            //   url: "/transaction-type/item-receipt",
            //   icon: <FileCopy />,
            // },
          ],
        },
        {
          title: "Accounts Payable",
          icon: <Money />,
          url: "",
  
          submenu: [
            {
              title: "Bill Payment List",
              url: "/transaction-type/bill-payment-list",
              icon: <PercentOutlined />,
            },
            {
              title: "Bill Credit List",
              url: "/transaction-type/bill-credit-list",
              icon: <BlindsClosed />,
            },
            {
              title: "Expense Reports",
              url: "/transaction-type/expense-report",
              icon: <SummarizeOutlined />,
            },
            {
              title: "Check",
              url: "/transaction-type/check",
              icon: <CheckBoxOutlined />,
            },
            /* ,*/
            // {
            //   title: "Vendor Bills",
            //   url: "/transaction-type/bill",
            //   icon: <QueryStats />,
            // },
            {
              title: "Vendor Return Authorization",
              url: "/transaction-type/vendor-return-authorization",
              icon: <TabOutlined />,
            },
          ],
        },
        {
          title: "Operations & Inventory",
          url: "",
          icon: <AccountTree />,
  
          submenu: [
           
            {
              title: "Item fulfillment",
              url: "/transaction-type/item-fulfillment",
              icon: <DynamicFeedOutlined />,
            },
            // {
            //   title: "Inventory Transfer (IT)",
            //   url: "/transaction-type/inventory-transfer",
            //   icon: <CurtainsClosed />,
            // },
            // {
            //   title: "Inventory Adjustment",
            //   url: "/transaction-type/inventory-adjustment",
            //   icon: <ComputerOutlined />,
            // },
            // {
            //   title: "Purchase Order",
            //   url: "/transaction-type/purchase-order",
            //   icon: <CheckCircle />,
            // },
            {
              title: "Item Receipt",
              url: "/transaction-type/item-receipt",
              icon: <FileCopy />,
            },
            // {
            //   title: "Inventory Transfer (OT)",
            //   url: "/transaction-type/inventory-transfer",
            //   icon: <CurtainsClosed />,
            // },
          ],
        },
        {
          title: "Finance",
          icon: <Book />,
          url: "",
  
          submenu: [
            {
              title: "Credit Card",
              url: "/transaction-type/credit-card",
              icon: <CreditCard />,
            },
            {
              title: "Deposit",
              url: "/transaction-type/deposit",
              icon: <AccountBalanceOutlined />,
            },
            {
              title: "Journal",
              url: "/transaction-type/journal",
              icon: <NewspaperOutlined />,
            },
            {
              title: "Credit Card Refund",
              url: "/transaction-type/credit-card-refund",
              icon: <StyleIcon />,
            },
            {
              title: "Transfer",
              url: "/transaction-type/transfer",
              icon: <CurtainsClosed />,
            },
            {
              title: "Estimate",
              url: "/transaction-type/estimate",
              icon: <ComputerOutlined />,
            },
          ],
        },
        {
          title: "Accounts Receivables",
          icon: <Money />,
          url: "",
          submenu: [
            {
              title: "Customer Refund",
              url: "/transaction-type/customer-refund",
              icon: <RedoOutlined />,
            },
          ],
        },
        {
          title: "Revenue",
          icon: <MonetizationOn />,
          url: "",
          submenu: [
            {
              title: "Revenue Arrangement",
              url: "/transaction-type/revenue-arrangement",
              icon: <Money />,
            },
          ],
        },
      ],
    },
    // {
    //   title: "Saved Search",
    //   url: "/saved-search",
    // },
    // {
    //   title: "Upload Files",
    //   url: "/upload-files-list",
    // },
    {
      title: "Accounts",
      url: "/accounts",
    },
    // {
    //   title: "Admin",
    //   url: "/PageDetailColumns",
    // },
    // {
    //   title: "Sales Order",
    //   url: "/salesOrderDynamicView",
    // },
    {
      title: "File Cabinet",
      url: "/fileCabinet",
    },
    {
      title: "Reports",
      url: "/reports",
    },
    {
      title: "Lists",
      url: "",
      submenu: [
        {
          title: "List with Name",
          url: "/lists",
          icon: <List />,
        },
       
          {
            title: "Transaction with Attachments",
            url: "/list-attachments",
            icon: <FileCopy />,
          },
       
      ],
    },
  
    {
      title: "Custom",
      icon: <Book />,
      url: "",
  
      submenu: [
        {
          title: "AP Check Request",
          url: "/transaction-type/custom",
          icon: <CreditCard />,
        },
       
      ],
    },
    
      {
        title: "Saved Search",
        url: "/saved-search",
      },
   
   
    // {
    //   title: "Amortization Reports",
    //   url: "/amortization-reports",
    // },
    // {
    //   title: "Transaction Total",
    //   url: "/transaction-total",
    // },
    // {
    //   title: "All Transactions",
    //   url: "/all-transactions",
    // },
    // {
    //   title: "Table Identification",
    //   url: "/table-identification",
    // },
  ];
 
  return (
    <nav className="no-print">
      <ul className="menus">
        {headerItems?.map((menu, index) => {
          const depthLevel = 0;
          return <MenuItems items={menu} key={index} depthLevel={depthLevel} />;
        })}
      </ul>
    </nav>
  );
};

export default Navbar;
